<template>
  <div class="image-preview">
    <!-- 缩略图 -->
    <img
      :src="src"
      class="thumb"
      @click="openPreview"
    />

    <!-- 遮罩层 + 大图 -->
    <div v-if="visible" class="preview-mask" @click="closePreview">
      <img :src="src" class="preview-img" />
      <!-- <button class="close-btn" @click.stop="closePreview">✕</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePreview',
  props: {
    src: {
      type: String,
      default: 'https://resource.51beauty.com.cn/qianduan_forever/3a9210e089824151a5c6dd62af753063/certificate.png',
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    openPreview() {
      this.visible = true
      document.body.style.overflow = 'hidden'  // 禁止滚动
    },
    closePreview() {
      this.visible = false
      document.body.style.overflow = '' // 恢复滚动
    }
  },
  beforeDestroy() {
    // 组件销毁时恢复滚动，防止意外
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.image-preview {
  min-height: 2px;
}
.thumb {
  width: 113px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
}

.preview-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.preview-img {
  max-width: 80%;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0,0,0,0.5);
}

.close-btn {
  position: fixed;
  top: 12px;
  right: 12px;
  font-size: 5px;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}
</style>
